import 'swiper/css'
import 'swiper/css/effect-creative'

import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay, EffectCoverflow } from "swiper/modules"
import { new3DSlider } from './NewAwardSection'
import { AnimatePresence, motion } from 'framer-motion'
import { captions } from './NewAwardSection'
import { useEffect, useMemo, useState } from 'react'
import NewAwardSection from './NewAwardSection'


const SuccessStory = () => {

    const [ index, setIndex ] = useState(0)

  useEffect(() => {
        const timer = setInterval(() => {
            setIndex((prev) => (prev + 1)%3)
        }, 4500)
        return () => clearInterval(timer)
    }, [])
   

    return (
        <NewAwardSection
            index={index}
        />
    )
}

export default SuccessStory;